import React, { useState, useEffect } from "react";
import { Select, MenuItem } from "@material-ui/core";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { useTranslation } from "react-i18next";

export default function Stop({ action, variables, setOpenVariable }) {

  const [content, setContent] = useState("noData");
  const { t } = useTranslation();
  useEffect(() => {
    if (!action.fields.responseType) {
      action.fields.responseType = { value: "noData", isRequired: true };
    } else {
      setContent(action.fields.responseType.value);
    }
  }, [action]);

  const handleContentSelect = (event) => {
    if (event.target.value === "noData") {
      action.fields.responseData.value = "";
      action.fields.responseData.htmlValue = "";
    }
    let value = event.target.value;
    action.fields.responseType.value = value;
    setContent(value);
  };


  return (
    <div>
      <div className="form-element">
        {t("CONTENT.CONFIGURATION-FORM.STOP.RESPONSE-TYPE")}
        <Select
          value={content}
          onChange={handleContentSelect}
          variant="outlined"
          fullWidth
          style={{ width: "90%" }}
        >
          <MenuItem value="noData">{t("CONTENT.CONFIGURATION-FORM.STOP.NO-DATA")}</MenuItem>
          <MenuItem value="application/json">application/json</MenuItem>
          <MenuItem value="application/xml">application/xml</MenuItem>
          <MenuItem value="text/plain">text/plain</MenuItem>
          <MenuItem value="text/xml">text/xml</MenuItem>
          <MenuItem value="text/html">text/html</MenuItem>
        </Select>
      </div>
      {content !== "noData" && (
        <div className="form-element">
          <TextInput
            action={action}
            inputName="responseData"
            variables={variables}
            setOpenVariable={setOpenVariable}
            multiline
            rows={4}
            isRequired={false}
          />
          <small>
            {"message : ''"}<br />
            {"status: ''"}<br />
            data: {action.fields.responseData?.value ? action.fields.responseData?.value : '{}'}
          </small>
        </div>
      )}
    </div>
  );
}
